/** @extends {ButtonController} */
import { Controller as ButtonController } from '../button/controller';

export class Controller extends ButtonController {
  static targets = ['loadingIcon', 'textContent'];

  connect() {
    super.connect();
    console.log('IconButtonController connected');
  }
}
